module.exports = __webpack_public_path__ + "img/buttomCut.61d955fc.svg";